import { useCallback } from 'react';
import { useI18n } from '../../context/I18nContext';
import { DICTS } from '../../i18n';
import { TRACKS, formatMoneyUSD, plansForTrack } from '../../constants/plans';

/** Cheapest paid couple plan in dollars — the "from" price quoted on the homepage. */
export const FROM_PRICE_AMOUNT = Math.min(
  ...plansForTrack(TRACKS.COUPLE).filter((p) => p.billingType === 'oneTime').map((p) => p.priceOnce)
);

/** FROM_PRICE_AMOUNT formatted, e.g. "$19". */
export const FROM_PRICE = formatMoneyUSD(FROM_PRICE_AMOUNT);

export const HOME_IMAGES = {
  heroCouple: '/images/landing/hero-couple.jpg',
  couplePhone: '/images/landing/couple-phone.jpg',
  wallVideo: '/images/landing/moments-wall.mp4',
  wallVideoTall: '/images/landing/moments-wall-portrait.mp4',
  wallPoster: '/images/landing/moments-wall-poster.jpg',
  venueDusk: '/images/landing/venue-dusk.jpg',
  waxSeal: '/images/landing/seal-gold.png',
  moments: [
    { key: 'dance', src: '/images/landing/moment-dance.jpg' },
    { key: 'toast', src: '/images/landing/moment-toast.jpg' },
    { key: 'grandma', src: '/images/landing/moment-grandma.jpg' },
    { key: 'confetti', src: '/images/landing/moment-confetti.jpg' },
    { key: 'cake', src: '/images/landing/moment-cake.jpg' },
    { key: 'firstdance', src: '/images/landing/moment-firstdance.jpg' },
  ],
};

export const INTRO_VIDEO = '/invitation-intro-demo.mp4';

/** Shared section heading styles. */
export const KICKER = 'text-[13px] font-semibold tracking-[0.14em] uppercase text-[#9A4357] dark:text-[#E8A5B4]';
export const H2 = 'font-playfair font-medium text-[34px] md:text-[44px] leading-[1.15] text-[#1C1A22] dark:text-stone-100';
export const BODY = 'text-[#4A4651] dark:text-stone-300';

function getPath(obj, path) {
  return path.split('.').reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

/**
 * Returns a lookup for non-string dictionary values (arrays of items) under `home.*`,
 * falling back to English when the active locale lacks the key.
 * @returns {(path: string) => Array<any>}
 */
export function useHomeList() {
  const { locale } = useI18n();
  return useCallback(
    (path) => {
      const value = getPath(DICTS[locale], `home.${path}`) ?? getPath(DICTS.en, `home.${path}`);
      return Array.isArray(value) ? value : [];
    },
    [locale]
  );
}

export function CheckIcon({ className = '' }) {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12l5 5L20 7" />
    </svg>
  );
}
